import {
	animateCountersIn,
	observeInView,
	getScrollRotator,
} from "@/js/animator";
import "./two-column-shortcode.scss";
